import React from 'react';
import { aboutPoints } from '../data/services';
import { about } from '../data/pages';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';
import MissionVision from '../components/MissionVision';

export default function About() {
  return (
    <section id="about" className="section">
      <div className="container">
        <Reveal><h2 className="bigh">Who We Are</h2></Reveal>
        <Reveal delay={80} className="prose prose--wide">
          {about.who.map((p) => <p key={p}>{p}</p>)}
        </Reveal>
        <Reveal delay={120}>
          <ul className="chips chips--gap">
            {aboutPoints.map((p) => (<li key={p}><Icon name="check" size={16} />{p}</li>))}
          </ul>
        </Reveal>
        <MissionVision />
      </div>
    </section>
  );
}
